import { useState, useEffect } from "react";
import app from "nystem";
import { Wrapper, ContentTypeRender } from "nystem-components";

const ViewButtonSelectGroup = ({ model, view, path }) => {
  const [active, setActive] = useState(false);

  const sendEvent = async () => {
    const data = await app.event(model.event, { value: view.value });

    setActive(true);

    return data;
  };

  useEffect(() => {
    const checkActive = (query) => {
      if (model.field && !query.count) {
        view.setValue({ path: model.field, value: query.value?._id });
        return;
      }

      if (!query.value && query.count) query.value = view.value;

      if (query.count) query.count++;
      else setActive(query.value._id === view.value._id);
    };

    if (model.field)
      setTimeout(async () => {
        const { count, value } = await app.event(model.event, { count: 1 });
        if (count !== 2) return;

        await app.event(model.event, { value });
      }, 250);

    app.on(model.event, model.field ? -10 : 10, checkActive);
    return () => {
      app.off(model.event, checkActive);
    };
  }, [model, view]);

  if (!model.item) return null;

  return (
    <Wrapper
      className={[
        model.className,
        active && model.activeClass,
        !active && model.inactiveClass,
      ]}
      onClick={sendEvent}
    >
      <ContentTypeRender path={path} items={model.item} />
    </Wrapper>
  );
};
export default ViewButtonSelectGroup;
